// '…'
export const ellipsis = String.fromCharCode(8230);
export const leftDoubleQuote = "“";
export const rightDoubleQuote = "”";
